import GridColumns from "../../../../../../packages/design-system/page/examples/constellation/grid-columns";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHgrid_columns from "!!raw-loader!../../../../../../packages/design-system/page/examples/constellation/grid-columns";
import * as React from 'react';
export default {
  GridColumns,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHgrid_columns,
  React
};